import React from 'react';
import './InstallerPayoutDashboard.scss';
const InstallerDashboard = (props) => {
  return (
    <div className="temporary-div">
      <p className="temp-para">This page is under maintenance</p>
    </div>
  );
};
export default InstallerDashboard;
